@if (menuItems && menuItems.length > 0) {
    <kendo-drawer #drawer [items]="menuItems" [autoCollapse]="false" [mini]="true">
        <ng-template kendoDrawerItemTemplate let-item>
            <a [routerLink]="item.routerLink" style="display: flex; align-items: center; padding: 0.75rem; color: white; text-decoration: none; border-radius: 0 !important">
                <kendo-svg-icon class="k-item-icon" [icon]="item.svgIcon" style="margin-left: -10px; margin-right: 10px"></kendo-svg-icon>
                @if (drawer.expanded) {
                    <span>{{ item.text }}</span>
                }
            </a>
        </ng-template>
        <ng-template kendoDrawerFooterTemplate>
            @if (drawer.expanded) {
                <div style="padding: 10px; top: auto; bottom: 0; position: absolute">
                    <img src="assets/images/company.png" style="margin-left: 38px; width: 100px; height: auto; margin-top: auto; margin-bottom: 0" />
                </div>
            }
        </ng-template>
    </kendo-drawer>
}
<!--
<mat-nav-list>
    <div class="p-10">
        <h3><strong>{{userSessionObject?.userName}}</strong></h3>

    </div>
    <mat-divider></mat-divider>
    <mat-list dense>
        <a mat-list-item routerLink="/aircrafts" routerLinkActive="active">
            <span style="display: flex; padding-left: 10px">
              <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
              Aircraft Data
            </span>
        </a>
        <mat-divider></mat-divider>
        <a mat-list-item routerLink="/atl" routerLinkActive="active">
          <span style="display: flex; padding-left: 10px">
            <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
            ATL List
          </span>
        </a>
        @if (userSessionObject.organizationId === 2 && passengersConfig?.enabled) {
          <mat-divider></mat-divider>
          <a mat-list-item routerLink="/passengers" routerLinkActive="active">
            <span style="display: flex; padding-left: 10px">
              <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
              Passengers
            </span>
          </a>
        }
        @if (showPilotHours) {
          <a mat-list-item routerLink="/statistic-pilot-hours" routerLinkActive="active">
            <span style="display: flex; padding-left: 10px">
              <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
              Statistic Pilot's Hours
            </span>
          </a>
          <mat-divider></mat-divider>
        }
        <h2 matSubheader> Flights </h2>
        <a mat-list-item routerLink="/flights" routerLinkActive="active">
          <span style="display: flex; padding-left: 10px">
            <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
            Completed Flights
          </span>
        </a>
        <mat-divider></mat-divider>
        <a mat-list-item routerLink="/export" routerLinkActive="active">
          <span style="display: flex; padding-left: 10px">
            <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
            Export Flights Data
          </span>
        </a>
        <h2 matSubheader> Inspections </h2>
        <a mat-list-item routerLink="/next-due-maintenances" routerLinkActive="active">
          <span style="display: flex; padding-left: 10px">
            <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
            Next Due Maintenances
          </span>
        </a>
        <mat-divider></mat-divider>
        <a mat-list-item routerLink="/hold-item-list" routerLinkActive="active">
          <span style="display: flex; padding-left: 10px">
            <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
            Hold Item Lists
          </span>
        </a>
        <mat-divider></mat-divider>
        @if (dailyCheckConfig?.enabled) {
          <a mat-list-item routerLink="/daily-checks" routerLinkActive="active">
            <span style="display: flex; padding-left: 10px">
              <mat-icon matListIcon>keyboard_arrow_right</mat-icon>
              Daily Checks
            </span>
          </a>
        }
    </mat-list>
</mat-nav-list>
-->
